@if (group.article_list.length > 0) {
  <div [formGroup]="form">
    <div class="row">
      <div class="col-md-12">&nbsp;</div>
    </div>
    <h4>Bestell Positionen für Gruppe: <strong>{{group.group.group_id}}. {{group.group.name}}</strong></h4>
    @if (materialFieldData.data$ | async; as fields) {
      <table class="table"
        >
        <thead>
          <tr>
            <th>Status</th>
            <th class="align-right">Pos.</th>
            <th class="align-right">Lief.</th>
            <th>Interne Nr.</th>
            <th>Art. Nr. Lief.</th>
            <th>Bezeichnung</th>
            @for (field of fields; track field) {
              <th>{{ field.name }}</th>
            }
            <th>Liefer-Termin (ETD)</th>
            <th class="align-right">Bestellt</th>
            @if (('material.order.price.check'|HasPerm)) {
              <th style="width: 60px;" class="align-right">Preis</th>
            }
            <th style="width: 200px;">Charge</th>
            <th style="width: 100px;">Lagerplatz</th>
            <th style="width: 110px;" class="align-right">Gelief. Menge</th>
            <th class="align-right">Verbleibend</th>
            <th class="icon"></th>
            <th class="icon"></th>
            <th class="icon"></th>
            <th class="icon"></th>
          </tr>
        </thead>
        @for (pForm of positionFormGroups; track trackByFnControl(iP, pForm); let iP = $index) {
          <tbody [material-order-intake-position]="group.article_list[iP]"
            [material-order-intake-position-form]="pForm"
            [material-order-intake-position-errors]="errors"
            [material-order-intake-position-fields]="fields"
            [material-order-intake-position-group-permit]="groupPermission"
            [material-order-intake-position-marked-variation-id]="markedVariationId"
            [material-order-intake-position-marked-position-id]="markedPositionId"
            [material-order-intake-position-marked-transaction-id]="markedTransactionId"
            (material-order-intake-position-add-transaction)="addTransactionPosition(iP, $event)"
            (material-order-intake-position-remove-transaction)="removeTransaction.emit($event)"
            (material-order-intake-position-update-order)="updateOrder.emit()"
            >
          </tbody>
        }
      </table>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }
    <loading-or-error
      #loadingOrError
      [loadingWrapper]="materialFieldData"
      [errorMessage]="'Konnte Material Felder nicht laden'"
      [spinnerSize]="2"
      spinnerName="circle-o-notch">
    </loading-or-error>
  </div>
}
